import React, { useState } from "react";

const portfolioData = [
  {
    id: 1,
    title: "Egg Cooker",
    image: "/img/eggcooker.jpeg",
    categories: ["ui-ux"], // Correction: On utilise un tableau directement
    projectLink: "https://apps.apple.com/fr/app/eggcooker/id6503665032"
  },
  {
    id: 2,
    title: "XO Clash",
    image: "/img/xoclash.jpeg",
    categories: ["jeu"],
    projectLink: "https://apps.apple.com/fr/app/xoclash/id6503460542"
  },
  {
    id: 3,
    title: "Pic Wander",
    image: "/img/case-3.jpg",
    categories: ["ui-ux", "achat"],
    projectLink: ""
  },
  {
    id: 4,
    title: "RPS Arena",
    image: "/img/rpsarena.jpeg",
    categories: ["jeu"],
    projectLink: "https://apps.apple.com/fr/app/rps-arena/id6503914026"
  },
];

const categories = [
  { id: "all", label: "Tout" },
  { id: "jeu", label: "Jeux" },
  { id: "ui-ux", label: "UI/UX" },
  { id: "achat", label: "Avec Paiement" }
];

const PortfolioTwo = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");

  // Fonction pour filtrer les projets
  const filteredPortfolio = selectedCategory === "all"
    ? portfolioData
    : portfolioData.filter(item => item.categories.includes(selectedCategory));

  return (
    <section className="works explore-area portfolio-filter pt-0">
      <div className="container p-0">
        <div className="row justify-content-center text-center">
          <div className="col-12">
            <div className="btn-group filter-menu" role="group" aria-label="Basic radio toggle button group">
              {categories.map(({ id, label }) => (
                <div key={id} className="input-item d-flex">
                  <div className="content">
                    <input
                      type="radio"
                      className="btn-check filter-btn"
                      name="shuffle-filter"
                      id={id}
                      value={id}
                      checked={selectedCategory === id}
                      onChange={() => setSelectedCategory(id)} // Met à jour l'état
                    />
                    <label className="btn" htmlFor={id}>{label}</label>
                  </div>
                  <span className="count">{portfolioData.filter(item => item.categories.includes(id) || id === "all").length}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="row filter-items items inner">
          {/* Dynamically rendering Portfolio Items based on the selected filter */}
          {filteredPortfolio.map((item) => (
            <div key={item.id} className="col-12 col-lg-4 item filter-item">
              {/* Portfolio Item */}
              <div className="card portfolio-item layout-2 scale has-shadow">
                <div className="image-holder">
                  {/* Card Thumb */}
                  <a className="card-thumb" href={item.projectLink}>
                    <img src={item.image} alt={item.title} />
                  </a>
                </div>
                {/* Card content */}
                <div className="card-content p-2">
                  <div className="heading">
                    <h4 className="title mt-2 mt-md-3 mb-3">{item.title}</h4>
                    <div className="show-project">
                      <div className="card-terms">
                        {item.categories.map((category, index) => (
                          <a key={index} className="terms badge" href="/portfolio">
                            {category.replace("-", " ")}
                          </a>
                        ))}
                      </div>
                      <div className="project-link">
                        <a href={item.projectLink}>Montrer le projet</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioTwo;